// src/services/userService.js

import apiClient from "./apiClient";

// Use centralized API client for consistent error handling
const api = apiClient;

// English only comments:
// Admin usage: get all users
export const getAllUsers = async () => {
  const res = await api.get('/api/users');
  return res.data;
};

// Admin usage: create user directly (NOT recommended for normal signups)
export const createUser = async (userData) => {
  const res = await api.post('/api/users', userData);
  return res.data;
};

// Get current user profile
export const getUserProfile = async () => {
  try {
    const response = await api.get('/api/users/profile');
    return response.data;
  } catch (error) {
    console.error('Error fetching user profile:', error);
    throw error;
  }
};

// Update user profile
export const updateUserProfile = async (profileData) => {
  try {
    const response = await api.patch('/api/users/profile', profileData);
    return response.data;
  } catch (error) {
    console.error('Error updating user profile:', error);
    throw error;
  }
};

// Update user email
export const updateUserEmail = async (email) => {
  try {
    const response = await api.patch('/api/users/profile/email', { email });
    return response.data;
  } catch (error) {
    console.error('Error updating user email:', error);
    throw error;
  }
};

// Change user password
export const changePassword = async (currentPassword, newPassword) => {
  try {
    const response = await api.patch('/api/users/profile/password', {
      currentPassword,
      newPassword
    });
    return response.data;
  } catch (error) {
    console.error('Error changing password:', error);
    throw error;
  }
};

// Update user avatar
export const updateUserAvatar = async (avatar) => {
  const response = await api.patch("/api/users/profile/avatar", { avatar });
  return response.data;
};

// Avatar upload functionality
export const uploadUserAvatar = async (file) => {
  try {
    const formData = new FormData();
    formData.append('avatar', file);
    
    const response = await api.post('/api/users/profile/avatar/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    
    return response.data;
  } catch (error) {
    console.error('Error uploading avatar:', error);
    throw error;
  }
};

export const deleteUserAvatar = async () => {
  try {
    const response = await api.delete('/api/users/profile/avatar');
    return response.data;
  } catch (error) {
    console.error('Error deleting avatar:', error);
    throw error;
  }
};

// File validation utility
export const validateAvatarFile = (file) => {
  const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
  const maxSize = 5 * 1024 * 1024; // 5MB
  
  if (!allowedTypes.includes(file.type)) {
    throw new Error('Invalid file type. Please upload a JPEG, PNG, or WebP image.');
  }
  
  if (file.size > maxSize) {
    throw new Error('File size exceeds 5MB limit.');
  }
  
  if (file.size < 100) {
    throw new Error('File too small. Please upload a valid image file.');
  }
  
  return true;
};
